const capitalizeFirstLetter = (word) => {
  return word.charAt(0).toUpperCase() + word.slice(1)
}

export const convertString = (str) => {
  const words = str.split('-') // Split the string by '-'
  const capitalizedWords = words.map((word) => capitalizeFirstLetter(word))
  return capitalizedWords.join(' ') // Join the words with a space
}
